export enum InteractionStatus{
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  WAITING_FOR_DOCESTATE = "WAITING_FOR_DOCESTATE"
}
